<template>
  <div>
    <BaseTitle :title="$t('menu.manage_quiz')" :yearPeriode="titleData" />
    <v-card class="mb-7">
      <div class="pa-5">
        <h3>{{ $t('filter') }}</h3>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.gradeId"
              item-value="gradeId"
              item-text="gradeName"
              clearable
              :items="classLevel"
              :label="$t('content.class_level')"
              @change="getCourse"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select v-model="form.courseId" item-value="courseId" item-text="name" clearable :items="course" :label="$t('menu.course')" />
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('menu.manage_quiz') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div v-if="permissionButton('ROLE_QUIZ_CREATE') || permissionButton('ROLE_QUIZ_LITE_CREATE')">
              <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="add">{{ $t('add') }}</v-btn>
            </div>

            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in listData" :key="item.userId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="iq" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content ">{{ item.quizTitle }} </span>

                  <span class="text-caption green--text ml-1" v-if="item.imported === true" style="font-size:5em;">
                    {{ $t('content.imported') }}
                  </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('form.status') }}:
                      <strong v-if="item.status" class="green--text font-italic header-content">{{ $t('form.active') }}</strong>
                      <strong v-else class="red--text font-italic header-content">{{ $t('form.noactive') }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('content.class_level') }}:
                      <strong>{{ item.grade }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('form.course') }}:
                      <strong>{{ item.course }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('roles.teacher') }}:
                      <strong style="color :#56A6DC;">{{ item.createdBy }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-if="permissionButton('ROLE_QUIZ_VIEW') || permissionButton('ROLE_QUIZ_LITE_VIEW')">
                        <v-list-item-title class="text-dropdown" @click="viewItem(item)">{{ $t('content.view_quiz') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (item.editable === true && permissionButton('ROLE_QUIZ_UPDATE')) ||
                            (item.editable === true && permissionButton('ROLE_QUIZ_LITE_UPDATE'))
                        "
                      >
                        <v-list-item-title class="text-dropdown" @click="editItem(item)">{{ $t('edit') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (item.editable === true && permissionButton('ROLE_QUIZ_DELETE')) ||
                            (item.editable === true && permissionButton('ROLE_QUIZ_LITE_DELETE'))
                        "
                      >
                        <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item)">{{ $t('table.delete') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (item.editable === false && permissionButton('ROLE_QUIZ_VIEW')) ||
                            (item.editable === false && permissionButton('ROLE_QUIZ_LITE_VIEW'))
                        "
                      >
                        <v-list-item-title class="text-dropdown" @click="viewChart(item)">{{ $t('content.view_stats') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listData.length" />
        <!-- <form @submit.prevent="submit">
          <v-data-table
            :headers="tableHeader"
            :items="items"
            :loading="table.loading"
            :server-items-length="items.length"
            :options.sync="table.options"
            hide-default-footer
            class="table-custom"
          >
            <template #top>
              <table-header @fetch="getData">
                <template slot="left">
                  <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="add">{{ $t('add') }}</v-btn>
                </template>
              </table-header>
            </template>
            <template #item.actions="{ item }">
              <v-btn text @click="onDeleteItem(item)" v-if="item.editable === true" class="mr-1 btn-action-custom">
                <svg-icon icon="delete" class="red--text" />
              </v-btn>
              <v-btn text @click="viewItem(item)" class="mr-1 btn-action-custom"><svg-icon icon="view" class="primary--text"/></v-btn>

              <v-btn text @click="viewChart(item)" v-if="item.editable === false" class="mr-1 btn-action-custom">
                <v-icon class="primary--text">mdi-chart-bar</v-icon></v-btn
              >
              <v-btn text @click="editItem(item)" v-if="item.editable === true" class="btn-action-custom"
                ><svg-icon icon="edit" class="primary--text"
              /></v-btn>
            </template>
            <template #item.status="{ item }">
              <strong v-if="item.status" class="green--text font-italic">{{ $t('active') }}</strong>
              <strong v-else class="red--text font-italic">{{ $t('inactive') }}</strong>
            </template>
            <template #no-data>
              <NoData />
            </template>
          </v-data-table>
          <table-footer @fetch="getData" />
        </form> -->
      </div>
    </v-card>

    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="table.loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';

export default {
  name: 'QuizTeacherList',
  components: {
    BaseTitle,
    // TableHeader,
    // TableFooter,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      course: 'QuizTeacher/courses',
      classLevel: 'QuizTeacher/classLevel',
      items: 'QuizTeacher/items',
      permission: 'Auth/permission',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    tableHeader() {
      return [
        { text: this.$t('table.name'), value: 'quizTitle' },
        { text: this.$t('content.class_level'), value: 'grade' },
        { text: this.$t('form.course'), value: 'course' },
        { text: this.$t('table.status'), value: 'status' },
        { text: this.$t('table.action'), value: 'actions', sortable: false }
      ];
    }
  },
  data: () => ({
    dialogDelete: false,
    currentItem: null,
    dataClass: '',
    listData: [],
    search: '',
    loadingLoad: false,
    form: {
      gradeId: null,
      courseId: null
    },
    table: {
      loading: false,
      options: {}
    },
    titleData: ''
  }),
  watch: {
    form: {
      deep: true,
      handler() {
        this.getData();
      }
    },
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    // getData() {
    //   this.table.loading = true;
    //   this.$store.dispatch('QuizTeacher/fetchList', { ...this.form, ...this.table.options }).finally(() => (this.table.loading = false));
    // },
    getData() {
      if (this.form.courseId || this.form.gradeId || (this.form.courseId && this.form.gradeId)) {
        this.getFilter();
      } else {
        this.loadingLoad = true;
        this.$store
          .dispatch('QuizTeacher/fetchList', {
            search: this.search
          })
          .then(data => (this.listData = data))
          .finally(() => (this.loadingLoad = false));
      }
    },
    getFilter() {
      if (this.form.courseId || this.form.gradeId || (this.form.courseId && this.form.gradeId)) {
        this.loadingLoad = true;
        this.$store
          .dispatch('QuizTeacher/fetchList', {
            courseId: this.form.courseId,
            gradeId: this.form.gradeId,
            search: this.search
          })
          .then(data => (this.listData = data))
          .finally(() => (this.loadingLoad = false));
      } else {
        this.getData();
      }
    },
    getDataGradeId() {
      this.loadingLoad = true;
      this.$store
        .dispatch('QuizTeacher/fetchListGradeId', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
        .then(res => {
          this.form.courseId = res.courseId;
          this.form.gradeId = res.gradeId;

          this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse', res.gradeId);
        })
        .finally(() => (this.loadingLoad = false));
    },
    getClassLevel() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse');
    },
    getCourse() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse', this.form.gradeId);
    },
    add() {
      if (this.isClass) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'QuizTeacherCreateClass' });
        } else {
          this.$router.push({ name: 'QuizTeacherSectionCreateClass' });
        }
      } else {
        this.$router.push({ name: 'QuizTeacherCreate' });
      }
    },
    viewItem({ quizId: id }) {
      if (this.isClass) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'QuizTeacherViewClass', params: { id } });
        } else {
          this.$router.push({ name: 'QuizTeacherSectionViewClass', params: { id } });
        }
      } else {
        this.$router.push({ name: 'QuizTeacherView', params: { id } });
      }
    },
    viewChart({ quizId: id }) {
      if (this.isClass) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'TeacherQuizStatsClass', params: { id } });
        } else {
          this.$router.push({ name: 'TeacherSectionQuizStatsClass', params: { id } });
        }
      } else {
        this.$router.push({ name: 'TeacherQuizStats', params: { id } });
      }
    },
    editItem({ quizId: id }) {
      if (this.isClass) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'QuizTeacherEditClass', params: { id } });
        } else {
          this.$router.push({ name: 'QuizTeacherSectionEditClass', params: { id } });
        }
      } else {
        this.$router.push({ name: 'QuizTeacherEdit', params: { id } });
      }
    },
    onDeleteItem({ quizId }) {
      this.currentItem = quizId;
      this.dialogDelete = true;
    },
    deleteItem() {
      if (!this.currentItem) return;
      this.table.loading = true;
      this.$store
        .dispatch('QuizTeacher/destroy', this.currentItem)
        .then(data => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .finally(() => (this.table.loading = false));
    }
  },
  created() {
    this.getData();
    this.$store.commit('table/RESET_PAGEABLE');
    this.getClassLevel();
    if (this.isClass) {
      this.getDataClass();
      this.getCourse();
      this.getDataGradeId();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
